// extracted by mini-css-extract-plugin
export default {"master":"master_master__yYUDY"};